



















import Vue from 'vue';
import shortkey from "vue-shortkey";
import { State, Action, Getter } from "vuex-class";
import { Component, Prop } from "vue-property-decorator";

Vue.use(shortkey);

/*
    * Component's properties and events
*/
@Component({})

export default class HotKeyComponent extends Vue{
    _hkActions(event) {
        let context = this.$store.state.dashboard,
            selectedComponent = context.selectedComponent.replace(/Component/g, "");

        selectedComponent = selectedComponent.charAt(0).toLowerCase() + selectedComponent.slice(1);
        context = this.$store.state[selectedComponent];

        switch (event.srcKey) {
            case 'add':
                if (context.card.type == context.type._grid && context.hideButtons.indexOf('Add') == -1) {
                    //#.Add form are triggered with the store.dispatch method.
                    this.$store.dispatch('add', { context: context, self: this });
                }
                break;
            case 'edit':
                //#.Enable form edit are triggered with the store.dispatch method.
                if (context.card.type == context.type._form)
                    this.$store.dispatch('edit', context);
                break;
            case 'cancel':
                //#.Remove title search are triggered with the store.dispatch method.
                if (context.card.type == context.type._form && context.renderTitleSearchComponent == false)
                    this.$store.dispatch('removeSearch', context);
                else if (context.card.type == context.type._form && context.renderTitleSearchComponent == true)
                    this.$store.dispatch('removeEdit', { context: context, self: this });
                break;
            case 'save':
                break;
            case 'search':
                //#.Enable title search are triggered with the store.dispatch method.
                if (context.card.type == context.type._form)
                    this.$store.dispatch('search', context);
                break;

            case 'down':
                break;

            case 'up':
                break;

            case 'shiftUp':
                break;

            case 'shiftDown':
                break;

            case 'delete':
                break;

            case 'edit':
                break;

            case 'cancel':
                break;

            case 'add':
                break;
        }
    }
};
